import { useState } from 'react';

import { Row, Col } from "reactstrap";

import PrismCodeDisplayer from "../PrismCodeDisplayer/PrismCodeDisplayer.js"


import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";



const ChatMessageRenderer = ({ blocks }) => {

  if (!Array.isArray(blocks)) return null;

  return (
    <div className="blocks">
      {blocks.map((b, i) => {
        if (!b || typeof b !== 'object') return null;

        switch (b.type) {
          case "title":
            return <h4 key={i} className="block-title">{b.text}</h4>;

          case "text":
            // Minimal markdown support: bold **x**, inline code `x`
            //markdown → If you want the AI to return formatted strings like bold, italic, code blocks, lists, etc.
            // (For real markdown, replace with a markdown lib.)
            return (
              <div key={i} className="block-text">

                {/* <ReactMarkdown>{b.markdown ?? b.text ?? ""}</ReactMarkdown> */}

                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  components={{
                    p: ({ children }) => <span>{children}</span>, // avoid <p> inside <li>
                  }}
                >
                  {String(b.markdown ?? b.text ?? "")}
                </ReactMarkdown>
              </div>
            );

          case "code":
            return (
              <div key={i} className="">
                {b.filename ? <div className="filename">{b.filename}</div> : null}
                {/* <pre><code>{b.code}</code></pre> */}
                <PrismCodeDisplayer codeToDisplay={b.code}></PrismCodeDisplayer>
              </div>
            );

          case "callout":
            return (
              <div key={i} className="block-callout">
                {b.markdown}
              </div>
            );

          case "steps":
            // return (
            //     <ol key={i} className="block-steps">
            //         {(b.items || []).map((step, idx) => (
            //             <li key={`${i}-${idx}`}>
            //                 {/* Render markdown inline inside <li> without extra <p> */}
            //                 <ReactMarkdown
            //                     remarkPlugins={[remarkGfm]}
            //                     components={{
            //                         p: ({ children }) => <span>{children}</span>, // avoid <p> inside <li>
            //                     }}
            //                 >
            //                     {String(step ?? "")}
            //                 </ReactMarkdown>
            //             </li>
            //         ))}
            //     </ol>
            // );

            return (
              <ol key={i} className="block-steps">
                {Array.isArray(b.items) && b.items.map((step, idx) => (
                  <li key={idx}>
                    <ReactMarkdown
                      remarkPlugins={[remarkGfm]}
                      components={{
                        p: ({ children }) => <span>{children}</span>, // avoid <p> inside <li>
                      }}
                    >
                      {String(step ?? "")}
                    </ReactMarkdown>
                  </li>
                ))}
              </ol>
            );

          case "list":
            return (
              <ul key={i} className="block-list">
                {Array.isArray(b.items) && b.items.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            );

          default:
            return <pre key={i} className="block-unknown">{JSON.stringify(b, null, 2)}</pre>;
        }
      })}
    </div>
  );


}



export default ChatMessageRenderer;